import React, { lazy } from 'react';
import PrivateRoute from '@/privateRoute';

const Verify = lazy(() => import('.'));

const routes = [
  {
    path: '/verify',
    element: (
      <PrivateRoute>
        <Verify />
      </PrivateRoute>
    ),
    title: 'Verify User'
  }
];

export default routes;
